import { UserService } from '@kp/rest-api-javascript-sdk';

export const getUserTenants = (skip?: number, limit?: number) =>
  UserService.getUsersTenants({ query: { skip, limit } });
